export default "__VITE_ASSET__CiptW$Wm__"